import React from 'react';
import { makeStyles } from '@material-ui/core';
import { func, node, string, bool, oneOfType } from 'prop-types';
import { Link } from 'react-router-dom';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import PhoneIcon from '@material-ui/icons/Phone';
import PrivacyPolicy from '../PrivacyPolicy';
import Button from '../Button';
import Typography from '../Typography';
import ROUTES, { getPath } from '../../routes';
import { makeURLWithParams } from '../../utils/globals';
import messages from './messages';
import { useConnect } from './hooks';

const useStyles = makeStyles(() => ({
  button: {
    marginTop: 12,
  },
  checkbox: {
    marginTop: 12,
  },
  container: {
    maxWidth: '700px',
    height: '100%',
  },
  divider: {
    width: '100%',
    alignSelf: 'flex-end',
  },
}));

const EmergencyButton = ({ phoneNumber }) => {
  return (
    <Grid container name="emergency" alignItems="center" justify="center">
      <Grid item>
        <PhoneIcon color="secondary" />
      </Grid>
      <Grid item>
        <Button content={messages.emergency} href={`tel:${phoneNumber}`} variant="underlined" />
      </Grid>
    </Grid>
  );
};

EmergencyButton.propTypes = {
  phoneNumber: string,
};

const MyCheckbox = ({ className, onChange }) => {
  return (
    <Grid container name="checkbox" className={className} wrap="nowrap">
      {onChange !== true && (
        <Grid item>
          <Checkbox onChange={onChange} />
        </Grid>
      )}
      <Grid item container alignItems="center" spacing={1}>
        <Grid item>
          <Typography content={messages.checkbox} />
        </Grid>
        <Grid item>
          <Link to={makeURLWithParams(getPath(ROUTES.LEGISLATION), { pdf: 'term_condition' })} target="_blank">
            <Typography content={messages.termsAgreementLink} />
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
};

MyCheckbox.propTypes = {
  className: string,
  onChange: func,
};

const Footer = ({ checkbox, children, direction = 'row', emergency, option, privacyPolicy }) => {
  const classes = useStyles();
  const { isDownsized } = useConnect();
  return (
    <Grid container name="footer" className={classes.container}>
      {privacyPolicy && <PrivacyPolicy />}
      {emergency && <EmergencyButton phoneNumber={emergency} />}
      {!isDownsized && <Divider className={classes.divider} />}
      {checkbox && <MyCheckbox className={classes.checkbox} onChange={checkbox} />}
      <Grid item>{option}</Grid>
      <Grid item container className={classes.button} direction={direction} justify="center" spacing={1}>
        {React.Children.toArray(children).map(child => (
          <Grid item key={child.key} xs>
            {child}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
Footer.displayName = 'Footer';

Footer.propTypes = {
  checkbox: oneOfType([func, bool]),
  privacyPolicy: bool,
  children: node.isRequired,
  direction: string,
  emergency: string,
  option: node,
};

export default Footer;
